// extracted by mini-css-extract-plugin
export default {"container":"dN-z","dimension":"eN-z","dimensionLabels":"fN-z"};